import React, { Component } from 'react';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import Masonry from 'react-masonry-css';
import Strings from 'components/Strings';
import Wish from 'components/Wish';
import './myWillBuys.css';

class MyWillBuys extends Component {
  renderEmpty() {
    return 'You haven\'t marked any wish to buy.'
  }

  renderMyWillBuys() {
    const { wishIds } = this.props

    const breakpointCols = {
      default: 4,
      1200: 3,
      900: 2,
      650: 1
    };

    return (
      <Masonry breakpointCols={ breakpointCols } className="MyWillBuys-Masonry" columnClassName="MyWillBuys-column">
        { !!wishIds.map && wishIds.map(wishId => this.renderItem(wishId)) }
      </Masonry>
    );
  }

  renderItem(wishId) {
    return (
      <div className="MyWillBuys-item" key={ wishId }>
        <Wish wishId={ wishId } />
      </div>
    )
  }

  renderLoading() {
    return <Strings label="loading" />
  }

  render() {
    const { wishIds } = this.props;

    return (
      <div className="MyWillBuys">
        {
          isLoaded(wishIds)
          ? isEmpty(wishIds)
            ? this.renderEmpty()
            : this.renderMyWillBuys()
          : this.renderLoading()
        }
      </div>
    );
  }
}

export default MyWillBuys;



// WEBPACK FOOTER //
// ./src/components/MyWillBuys/MyWillBuys.js